import RecordSelector from "./RecordSelector";

interface ReferencesSectionSelectorProps {
  name: string;
}

export default function ReferencesSectionSelector({
  name,
}: ReferencesSectionSelectorProps) {
  const formatOptionLabel = (option: any) => {
    return (
      <div>
        <div className="font-medium">{option.label}</div>
        {option.description && (
          <div className="text-sm text-gray-600">{option.description}</div>
        )}
      </div>
    )
  };

  return (
    <RecordSelector
      name={name}
      isMulti={false}
      searchUrl="/admin/references_sections/search"
      label="References Section"
      formatOptionLabel={formatOptionLabel}
      manageUrl="/admin/reference"
      manageLabel="Manage or create references sections"
    />
  )
}
